/**
 * Default widget for dropdown, barcode, checkboxlist, and radiobuttonlist
 */

export function createDefaultDropdown() {
    return {
        "id": "",
        "name": "",
        "type": "< no dropdowns >",
        "properties": {
            "options": [{
                "name": "",
                "id": ""
            }]
        }
    };
}

export function createDefaultBarcode() {
    return {
        "id": "",
        "name": "",
        "type": "< no barcode widgets >",
        "properties": null
    };
}

export function createDefaultCheckboxList() {
    return {
        "id": "",
        "name": "< no checkboxes >",
        "type": "checkboxlist",
        "properties": {
            "checkboxes": [{
                "id": "",
                "name": "< no checkboxes >",
                "type": "checkbox",
                "properties": {"value": ""}
            }]
        }
    };
}

export function createDefaultRadiobuttonList() {
    return {
        "id": "",
        "name": "",
        "type": "< no radio buttons >",
        "properties": {
            "options": [{
                "name": "",
                "id": "",
                "properties": {"value": ""}
            }]
        }
    };
}
